export const LEARN_VERTICAL_ID = 1;
export const SCA_VERTICAL_ID = 2;

export const VALID_VERTICAL_IDS = [LEARN_VERTICAL_ID, SCA_VERTICAL_ID];

export const INDIAN_ISD_CODE = "+91";

export const BUSINESS_VERTICAL_IDS = [
  {
    id: LEARN_VERTICAL_ID,
    value: "1",
    label: "Learn",
  },
  {
    id: SCA_VERTICAL_ID,
    value: "2",
    label: "SCA",
  },
];

export const LEARN_TENANT_ID = 1;
export const LEARN_PRODUCT_ID = 300;

export const CHEQUE_METHOD_ID = 16;

export const CHEQUE_STATUS_IDS = {
  CREATED: 1,
  VERIFIED: 2,
  DISBURSED: 3,
  CANCELLED: 4,
  FAILED: 5,
};

export const SUCCESSFUL_ONLINE_TRANSACTION_STATUS_ID = 3;

export const VERTICAL_NAME = {
  [SCA_VERTICAL_ID]: "SCA",
  [LEARN_VERTICAL_ID]: "Learn",
};

export const SEARCH_USER_DETAILS_TYPE = {
  PHONE_NUMBER: "phone_number",
  APPLICATION_NUMBER: "application_number",
};

export const SUCCESSFUL_PAYMENT_STATUS_IDS = [7, 8];
export const ADJUSTMENT_AGAINST_REFUNDS_PAYMENT_ID = 14;

export const ORDER_STATUSES = {
  ACCEPTED: 1,
  FULLY_PAID: 2,
  DISCARDED: 3,
  CANCELLATION_REQUESTED: 4,
  CANCELLED: 5,
  SUSPENDED: 6,
};

export const INVOICE_DETAILS_COLUMN = [
  { label: "Billing Entity", field: "billingEntity" },
  { label: "Invoice Number", field: "invoiceNumber" },
  { label: "Invoice Date", field: "invoiceDate" },
  { label: "Amount", field: "amount" },
  { label: "Download", field: "download" },
];

export const ORGANIZATIONS = [
  { id: 1, label: "Brownstone Education Private Limited", value: 1 },
  { id: 2, label: "Rankguru Technology Solutions Private Limited", value: 2 },
];

export const ORGANIZATIONS_SELECT_OPTIONS = [
  { id: 1, label: "Brownstone Education Private Limited", value: 1 },
  { id: 2, label: "Rankguru Technology Solutions Private Limited", value: 2 },
];

export const CENTER_CASHIER_LIST_COLUMNS = [
  { label: "Cashier Name", field: "cashierName" },
  { label: "Cash In-hand", field: "cashInHand" },
  { label: "Deposit Amount", field: "depositAmount" },
  { label: "Balance Cash In-hand", field: "balanceCashInHand" },
];

export const DENOMINATION_UNITS = [
  { value: 2000, label: "2000x" },
  { value: 1000, label: "1000x" },
  { value: 500, label: "500x" },
  { value: 200, label: "200x" },
  { value: 100, label: "100x" },
  { value: 50, label: "50x" },
  { value: 20, label: "20x" },
  { value: 10, label: "10x" },
  { value: 5, label: "5x" },
  { value: 2, label: "2x" },
  { value: 1, label: "1x" },
];

export const TRANSACTION_RECORDS_COLUMN = [
  { label: "Application Number", field: "applicationNumber" },
  { label: "Order Status", field: "orderStatus" },
  { label: "Organization", field: "organization" },
  { label: "Payment Head", field: "paymentHead" },
  { label: "Payment Head Category", field: "paymentHeadCategory" },
  { label: "Invoice No.", field: "invoiceNo" },
  { label: "CGST(₹)", field: "cgst" },
  { label: "SGST(₹)", field: "sgst" },
  { label: "IGST(₹)", field: "igst" },
  { label: "Amount Collected exclusive of Taxes(₹)", field: "taxableAmount" },
  { label: "Amount Collected inclusive of taxes(₹)", field: "totalAmount" },
  { label: "Payment Created on", field: "paymentCreatedOn" },
  { label: "Payment Collected on", field: "paymentCollectedOn" },
  { label: "Payment Mode", field: "paymentMode" },
  { label: "Cheque Reference No.", field: "chequeReferenceNo" },
  { label: "Cheque Bank Name", field: "chequeBankName" },
  { label: "HSN/SAC Code", field: "hsnSacCode" },
];

export const SUMMARY_OF_TRANSACTIONS_HEADERS = [
  {
    label: "Current Closed Day Sheet Summary",
    field: "currentClosedDaySheetSummary",
  },
  { label: "Amount (₹)", field: "amount" },
];

export const CASH_DEPOSITS_COLUMN = [
  { label: "Organization", field: "organization" },
  { label: "Head Cashier's Name", field: "headCashierName" },
  { label: "Head Cashier's Ph. No.", field: "headCashierPhoneNumber" },
  { label: "Cash Deposit Date", field: "cashDepositedDate" },
  { label: "Cash In Hand(₹)", field: "cashInHand" },
  { label: "Cash Deposit Amount(₹)", field: "cashDepositedAmount" },
  { label: "Balance Amount (₹)", field: "balanceAmount" },
];
export const POST_SUBMIT_RELOAD_DELAY_IN_MS = 2000;

export const PAYMENT_STATUS = {
  CREATED: 1,
  VERIFIED: 2,
  ACTIVATED_BY_PROVIDER: 3,
  REJECTED_BY_PROVIDER: 4,
  CANCELLED_BY_CUSTOMER: 5,
  REJECTED_BY_INFINITY_LEARN: 6,
  APPROVED_BY_PROVIDER: 7,
  DISBURSED: 8,
};

export const CASH_PAYMENT_METHOD_ID = 6;

export const RECEIPT_DOWNLOAD_RESTRICTION_START_DATE = new Date("2026-01-25T23:59:59Z");

export const CASH_IN_HAND_MISMATCH_THRESHOLD = 1;

export const SCA_ONE_APP_MIGRATED = true;